module.exports = __webpack_public_path__ + "img/nike.0df489ae.jpg";